import { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Button, Dialog, Stack, Typography } from '@mui/material';

import FullLogo from '@/components/FullLogo';
import { useAuthStyles } from '../AuthLayout';
import PinInput from '@/components/PinInput';
import AuthLayout from '../AuthLayout';
import { useLock } from '@/context/LockContext';
import AuthUserStore from '@/common/utils/AuthUser';

const useStyles = makeStyles(() => ({
  dialog: {
    margin: 0,
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    maxHeight: '100%',
    borderRadius: 0,
    zIndex: 1500,
    position: 'fixed'
  },
  header: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '22px'
  },
  pinInput: {
    padding: '16px 0px'
  },
  pinInputField: {
    '& .MuiInputBase-input': {
      backgroundColor: 'transparent',
      textAlign: 'center',
      fontSize: '32px'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none'
      }
    },
    '& .MuiInput-underline:before': {
      borderBottom: '3px solid black'
    },
    '& .MuiInput-underline:hover:before': {
      borderBottom: '3px solid black !important'
    },
    '& .MuiInput-underline:after': {
      borderBottom: '3px solid black'
    }
  }
}));

const LockScreen = () => {
  const classes = useStyles();
  const authClasses = useAuthStyles();
  const authUser = AuthUserStore.getAuthUser();
  const { description, storeCode } = authUser?.store || {};

  const { isPowLocked, unlockPow } = useLock();
  const [showForgotPage, setShowForgotPage] = useState(false);

  return (
    <Dialog
      open={isPowLocked}
      classes={{ paper: classes.dialog }}
      disableEscapeKeyDown
      container={document.body}
      onClose={unlockPow}
    >
      <AuthLayout>
        <FullLogo className={authClasses.contentLogo} />
        {!showForgotPage ? (
          <>
            <Typography className={classes.header} align="center">
              {description}
              <br />
              {storeCode}
            </Typography>
            <Stack className={authClasses.contentOuterStack}>
              <PinInput onSuccess={unlockPow} />
              <Button
                className={authClasses.extra}
                variant="text"
                onClick={() => setShowForgotPage(true)}
                disableRipple
              >
                I forgot my PIN
              </Button>
              <Button
                className={authClasses.extra}
                variant="text"
                onClick={() => AuthUserStore.logout()}
                disableRipple
              >
                Sign out
              </Button>
            </Stack>
          </>
        ) : (
          <>
            <Typography className={authClasses.header} align="center">
              I forgot my PIN
            </Typography>
            <Typography className={authClasses.message} align="center">
              To reset your PIN, sign in with your email and password, then
              click “Reset my PIN” in the user menu.
            </Typography>
            <Typography className={authClasses.message} align="center">
              Your Studio Owner or Manager can also reset your PIN for you.
            </Typography>
            <Button
              className={authClasses.extra}
              variant="text"
              onClick={() => setShowForgotPage(false)}
              disableRipple
            >
              Back to lock screen
            </Button>
          </>
        )}
      </AuthLayout>
    </Dialog>
  );
};

export default LockScreen;
